import { types } from 'mobx-state-tree'

export const SupplierModel = types.model('SupplierModel', {
  id: types.number,
  name: types.string,
  address: types.string,
  contacts: types.string,
  discount: types.string,
})
